import { useDataProvider } from 'react-admin';
import { useQuery } from 'react-query';

const useGetTeacherNativeLanguages = (teacherId) => {
  const dataProvider = useDataProvider();
  const query = useQuery(['getTeacherNativeLanguages', teacherId], () => {
    if (teacherId)
      return dataProvider
        .getTeacherNativeLanguages(teacherId)
        .then(({ data }) => data);
  });

  return query;
};

export default useGetTeacherNativeLanguages;
